/**
 * This file contains fallback/default colors only.
 * Actual colors are fetched from API and injected via ThemeContext.
 * Use useTheme() hook to get current colors from API.
 * 
 * CSS variables (--primary, --secondary) are automatically updated by useDynamicColors hook.
 */

export const colors = {
  // These are defaults/fallbacks only - actual colors come from API
  primary: {
    main: "#C44536", // Default fallback
    light: "#E55A4B",
    dark: "#A63429",
    gradient: "linear-gradient(135deg, #C44536 0%, #E55A4B 100%)",
  },
  secondary: {
    main: "#4CAF50", // Default fallback
    light: "#66BB6A",
    dark: "#388E3C",
  },
  accent: {
    yellow: "#fff200", // Salla yellow color
  },
  error: {
    main: "#F44336",
    light: "#EF5350",
    dark: "#D32F2F",
    bg: "#FFEBEE",
  },
  success: {
    main: "#4CAF50",
    light: "#81C784",
    dark: "#388E3C",
    bg: "#C8E6C9",
  },
  neutral: {
    white: "#FFFFFF",
    gray50: "#FAFAFA",
    gray100: "#F5F5F5",
    gray200: "#EEEEEE",
    gray300: "#E0E0E0",
    gray400: "#BDBDBD",
    gray500: "#9E9E9E",
    gray600: "#757575",
    gray700: "#616161",
    gray800: "#424242",
    gray900: "#212121",
  },
  background: {
    main: "#F8F9FA",
    card: "#FFFFFF",
  },
}
